module.exports = __webpack_public_path__ + "img/MA.9093d828.svg";